module.exports = __webpack_public_path__ + "img/icon_password.ee38b55d.svg";